<template>
	<transition name="fade-overlay">
		<section v-if="loading || content" :class="['overlay', { dark: target.dark }]">
			<transition name="fade">	
				<spinner v-if="loading" color="white" size="large"></spinner>
			</transition>
			<transition name="fade">	
				<div v-if="!loading" class="row">
					<div class="columns small-12 medium-10 medium-offset-1">
						<a href="#" aria-role="button" 
							id="globalOverlayClose" 
							class="overlay-toggle button close has-icon active" v-on:click.prevent="close">
							<span class="label" v-text="txtClose">
							</span>
						</a>
						<overlay-content :data="content" :columns="1"></overlay-content>
					</div>
				</div>
			</transition>
		</section>
	</transition>
</template>

<script>
export default {
	props: ['target'],
	data() {
		return {
			content: false,
			loading: false,
			showClose: false
		}
	},
	computed: {
		txtClose() {
			return this.$t('close') || '';
		}
	},
	components: {
		OverlayContent: () => import('../../blocks/overlay/Content'),
		Spinner: () => import('../../ruter/Spinner'),
	},
	methods: {
		onTargetClick() {
			if (!this.target.requestPath) {
				this.content = this.target.model
				setTimeout(() => { this.showClose = true; }, 300);
			} else {
				this.loading = true;
				this.$http.get(this.target.requestPath + this.target.model.id + '?lang=' + this.target.lang).then(response => {
					if (response.data.success) {
						if (response.data.note) {
							this.content = response.data.note.content;
							setTimeout(() => { this.showClose = true; }, 300);
						}
						this.loading = false;
					}
				});
			}
		},
		toggle() {
			if (this.content===false) {
				this.open();
			} else {
				this.close();
			}
		},
		close() {
			this.content = false;
			this.showClose = false;
			var overlayTriggerLink = document.querySelector('.active-overlay-trigger-link');
			if (typeof overlayTriggerLink !== 'undefined') {
				overlayTriggerLink.focus()
				overlayTriggerLink.classList.remove('active-overlay-trigger-link')
			}
		},
		closeAndReset() {
			document.body.classList.remove('overlay-open');
			if (this.showClose) this.close();
		},
		focusOnCloseButton() {
			var closeButton = document.getElementById('globalOverlayClose')
			if (typeof closeButton === 'undefined') return setTimeout(() => { this.focusOnCloseButton() }, 500)
			closeButton.focus()
		}
	},
	mounted() {
		this.$root.$on(`overlayTargetClicked__${this.target.index}`, this.onTargetClick
		);
	},
	beforeDestroy() {
		this.$root.$off(`overlayTargetClicked__${this.target.index}`, this.onTargetClick
		);
	},
	watch: {
		content(newVal) {
			if (newVal) {
				document.body.classList.add('overlay-open')
			} else {
				document.body.classList.remove('overlay-open')
			}
		},
		'$route'() {
			this.closeAndReset()
		},
		showClose(newVal) {
			if (newVal) this.focusOnCloseButton()
		}
	}
}
</script>